/**
 * Created by Ning Jiang on 10/10/2018.
 */

import { PunkParsedGameData } from "../../../../server/data/PunkParsedGameData";
import { EventHandler } from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import { GameEvent } from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import { StateSymbolWin } from "../../../independent/symbol/StateSymbolWin";
import { ReelGraphicBackground } from "../../../independent/background/ReelGraphicBackground";
import { StateHandler } from "@nolimitcity/slot-game/bin/core/utils/StateHandler";
import { AnimationEffects } from "../../../../effects/AnimationEffects";
import { PunkBackground } from "../../../../background/PunkBackground";
import { Container, BLEND_MODES } from "pixi.js";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import { IWinRatioConfig } from "@nolimitcity/slot-game/bin/core/winpresentation/WinRatio";
import { JumpingWildController, JumpWildState } from "../../../independent/jumpingWild/JumpingWildController";
import { ReelItemOverlay } from '../../../independent/overlay/ReelItemOverlay';
import { TweenLite } from "gsap";
import { PunkGameConfig } from "../../../../PunkGameConfig";
import { SoundConfig } from "../../../../SoundConfig";
import { SoundManager } from "../../../../resource/sound/SoundManager";
import { SlotGame } from "@nolimitcity/slot-game/bin/core/SlotGame";
import { WinCounter } from "../../../independent/countup/WinCounter";
import { Presentation, PresentationState } from "@nolimitcity/slot-game/bin/core/gamecontroller/presentations/Presentation";
import { SpinEvent } from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import { GameMode } from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import { PunkEngineManager } from "../../../../punkEngine/PunkEngineManager";
import { ReelSymbolStates } from "@nolimitcity/slot-game/bin/core/engines/reel/symbol/ReelSpriteSymbolArea";
import { PunkEngineController } from "../../../../punkEngine/PunkEngineController";
import { IPunkBetWinData } from "../../../../server/data/PunkServerData";
import { Sequence } from "@nolimitcity/slot-game/bin/core/displayobject/Sequence";
import {PunkGameModuleConfig} from "../../../../PunkGameModuleConfig";
import { PunkRocker } from "../../../../PunkRocker";

class WinState extends StateHandler{
    public static readonly WIN:string = "win";
    public static readonly SMALL_WIN:string = "small_win";
    public static readonly NORMAL:string = "normal";
    public static readonly BIGWIN:string = "bigwin";
    public static readonly DONE:string = "done";
}

export class NormalWinPresentation extends Presentation {

    private  _gameData:PunkParsedGameData;
    private _winState:WinState = new WinState();
    private _shatter:Sequence;

    private _soundWinTotal:string = "";

    private winAmount:number = 0;
    private winConfig:IWinRatioConfig;

    private clickAble:boolean = false;
    private bigWin:boolean = false;
    private winIndx:number = 0;

    private totalWinWays:number = 0;


    public initialization(){
        this._shatter = Sequence.createSequence(GameResources.getTextures("Shatter"));
        this._shatter.zIndex = 0;
        this._shatter.blendMode = BLEND_MODES.ADD;
        this._shatter.alpha = 0;
        this.addChild(this._shatter);
        this.sortChildren();
        this._shatter.position = new PIXI.Point(320,360);
    }

    public checkForActivation(data:PunkParsedGameData):boolean{ return data.singleWin > 0; }

    public setParsedGamedData(data:PunkParsedGameData):void{
        this._gameData = data;
        this.winAmount = data.singleWin;
        this.winConfig = data.currentWinRatioConfig!;

        // 423
        PunkGameConfig.instance.WIN_BELOW_STAKE = (SlotGame.api.gameClientConfiguration.belowStakeWinRestriction && (data.singleWin <= data.playedBetValue));

        this._winState.set(WinState.WIN);
        this.totalWinWays = data.allWinData.totalWinCombination;
        this.bigWin = data.isBigWin;
        if(!data.isBigWin){
            let indxNr:number = PunkGameConfig.instance.WIN_RATIOS.normalWin.findIndex((indx) => indx.ratio == this.winConfig.ratio);
            this.winIndx = indxNr;
            this._soundWinTotal = SoundConfig.instance.NORMAL_TOTAL_WINS[indxNr];

            if(indxNr <= 1) this._winState.set(WinState.SMALL_WIN);
            if(indxNr == 0) indxNr = -1;
            this._shatter.scale.set(1+indxNr,1+indxNr);
        }else{
            this._soundWinTotal = "";
        }
    }

    public getPresentation():void {
        switch(this._winState.state){
            case WinState.SMALL_WIN:
                this.SmallWin();
                break;
            case WinState.WIN:
                this.LightWinPositions();
                break;
            case WinState.NORMAL:
                this.addWinCountUpToTimeline();
                break;
            case WinState.BIGWIN:
                this.ShakePositions();
                break;
            default:
                this.PresentationState.set(PresentationState.INACTIVE);
                break;
        }
    }

    protected SmallWin():void{
        this._winState.set(WinState.DONE);
        WinCounter.winWayCounter.updateWinWays(this.totalWinWays);
        EventHandler.dispatchEvent(new GameEvent(SpinEvent.WANT_SKIPPABLE));

        const totalWin:number = this._gameData!.totalWin;
        const isTotalWin:boolean = totalWin != this._gameData.singleWin;

        this.clickAble = true;

        const us_nj = PunkRocker.api.gameClientConfiguration.displayIndividualWinsInGame && this._gameData.punkBetWins.length > 1;

        // Step Counter
        PunkEngineManager.RSWindow((reel:number,sym:number) =>  ReelItemOverlay.instance.nearWinSpot(reel,sym, 0.35,false))

        let playDuration:number = 0;
        let lightDuration:number = 0.20;
        let lightDurationDelay:number = lightDuration*0.25;
        let stopDelay:number = 0;

        for(let groups = 0; groups < this._gameData.punkBetWins.length;groups++){
            const winData:IPunkBetWinData = this._gameData.punkBetWins[groups];
            stopDelay = playDuration + (winData.length)*lightDurationDelay;// + lightDuration*0.5;
            let triggerValue:boolean = us_nj;
            for(let reel = 0; reel < winData.reelWinPositions.length;reel++){
                let posRow:boolean[] = winData.reelWinPositions[reel];
                for(let row = 0; row < posRow.length; row++){
                    if(posRow[row]){
                        if(JumpingWildController.instance.itemExists(reel,row) >= 0){
                            this.pTimeline.add(() => {
                                JumpingWildController.instance.PlayState(
                                    JumpingWildController.instance.itemExists(reel, row),
                                    JumpWildState.WIN
                                );
                            }, playDuration)
                        }

                        if(triggerValue && reel == winData.length-1 && posRow[row]){
                            this.pTimeline.add(() => {
                                ReelItemOverlay.instance.playValueText(reel, row, winData.amount , winData.numberOfCombinations)
                            }, playDuration + reel*lightDurationDelay);
                            triggerValue = false;
                        }

                        this.pTimeline.add(() => ReelItemOverlay.instance.lightPosition(reel, row, lightDuration , 0.4 + (reel*0.2)), playDuration + reel*lightDurationDelay);
                        this.pTimeline.add(() => ReelItemOverlay.instance.nearWinSpot(reel, row, lightDuration,false), stopDelay + reel*lightDurationDelay);
                    }
                }
            }
            if (!PunkGameConfig.instance.WIN_BELOW_STAKE) { // #423
                this.pTimeline.add(() => SoundManager.playSoundEffect(SoundConfig.instance.BETLINE_HIGHTLIGHT_TINY), playDuration);
            }
            playDuration += (winData.length)*lightDurationDelay + lightDuration*0.5 + (us_nj? 0.3:0);
        }

        this.pTimeline.add([
            () => !PunkGameConfig.instance.WIN_BELOW_STAKE && SoundManager.playSoundEffect(this._soundWinTotal), // #423
            () => WinCounter.normalCounter.getCountUpAnimation(0, this.winAmount, 0),
            () => !PunkGameConfig.instance.WIN_BELOW_STAKE && SoundManager.playSoundEffect(SoundConfig.instance.NORMAL_COUNTUP_END),
            () => WinCounter.normalCounter.playSizing(0.25, (1.1)),
            () => WinCounter.winWayCounter.showWaysWon(0.5)
        ],playDuration);

        this.pTimeline.add(() => SlotGame.keypad.setWin(totalWin,isTotalWin, PunkGameModuleConfig.featurePrice.isWinBelowStake()));
        this.pTimeline.to(this,0.55,{});
    }

    protected LightWinPositions():void{
        this._winState.set(this._gameData.isBigWin ? WinState.BIGWIN : WinState.NORMAL);
        PunkEngineManager.RSWindow((reel:number,sym:number) =>  ReelItemOverlay.instance.nearWinSpot(reel,sym, 0.35,false))

        let playDuration:number = 0.2;
        let lightDuration:number = 0.2;
        let lightDurationDelay:number = lightDuration*0.25;
        let stopDelay:number = 0;

        // const smallWinWin:boolean = this.winIndx == 1;

        for(let groups = 0; groups < this._gameData.punkBetWins.length;groups++){
            const winData:IPunkBetWinData = this._gameData.punkBetWins[groups];
            stopDelay = playDuration + (winData.length)*lightDurationDelay;// + lightDuration*0.5;
            for(let reel = 0; reel < winData.reelWinPositions.length;reel++){
                let posRow:boolean[] = winData.reelWinPositions[reel];
                let triggerValue:boolean = PunkRocker.api.gameClientConfiguration.displayIndividualWinsInGame;


                for(let row = 0; row < posRow.length; row++){
                    if(posRow[row]){
                        if(JumpingWildController.instance.itemExists(reel,row) >= 0){
                            this.pTimeline.add(() => JumpingWildController.instance.PlayState(
                                JumpingWildController.instance.itemExists(reel,row),
                                JumpWildState.WIN
                            ),playDuration)
                        }

                        if(triggerValue && reel == winData.length-1 && posRow[row]){
                            this.pTimeline.add(() => {
                                ReelItemOverlay.instance.playValueText(reel, row, winData.amount , winData.numberOfCombinations)
                            }, playDuration + reel*lightDurationDelay);
                            triggerValue = false;
                        }

                        this.pTimeline.add(() => ReelItemOverlay.instance.lightPosition(reel, row, lightDuration , 0.4 + (reel*0.2)), playDuration + reel*lightDurationDelay);
                        this.pTimeline.add(() => ReelItemOverlay.instance.nearWinSpot(reel, row, lightDuration,false), stopDelay + reel*lightDurationDelay);
                    }
                }
            }
            if (!PunkGameConfig.instance.WIN_BELOW_STAKE) { // #423
                this.pTimeline.add(() => SoundManager.playSoundEffect(SoundConfig.instance.BETLINE_HIGHTLIGHT), playDuration);
            }
            playDuration += (winData.length)*lightDurationDelay + lightDuration*0.5;
        }
        this.pTimeline.to(this,lightDuration*0.5,{});
    }

    public stopPresentation():void {
        PunkEngineManager.RSWindow((reelId:number,SymId:number) => {
            ReelItemOverlay.instance.nearWinSpot(reelId,SymId,0.2,false);
            if(!PunkEngineManager.getReel(reelId).getSymbol(SymId)!.isWild) PunkEngineManager.getReel(reelId).getSymbol(SymId)!.setActive(true);
        });

        if(!this.bigWin){
            WinCounter.normalCounter.abort(this.winAmount,this._winState.equal(WinState.BIGWIN));
        }
    }

    protected ShakePositions():void{
        SoundManager.playSoundEffect(SoundConfig.instance.BIG_WIN_INITIAL);

        const PlaceDurr:number = 1;
        for(let reel = 0; reel < this._gameData.allWinData.reelWinPositions.length;reel++){
            for(let row = 0; row < this._gameData.allWinData.reelWinPositions[reel].length;row++){
                if(this._gameData.allWinData.reelWinPositions[reel][row]){
                    if(JumpingWildController.instance.itemExists(reel,row) == -1){
                        this.pTimeline.add(() => StateSymbolWin.instance.playSymbolStartWinAnimation({
                            ReelID:reel,
                            SymID:row,
                            duration: PlaceDurr,
                            State:ReelSymbolStates.WIN,
                        }),reel*0.05)
                    }
               }
            }
        }

        let totalDurr:number = this.pTimeline.totalDuration() - PlaceDurr;
        const shakeDurr:number = 2;
        this.pTimeline.add(() => SoundManager.playSoundEffect(SoundConfig.instance.BETLINE_SHAKE),totalDurr + shakeDurr*0.5);
        for(let reel = 0; reel < this._gameData.allWinData.reelWinPositions.length;reel++){
            const reelC:PunkEngineController = PunkEngineManager.getReel(reel);
            for(let row = 0; row < this._gameData.allWinData.reelWinPositions[reel].length;row++){
                if(this._gameData.allWinData.reelWinPositions[reel][row]){
                    let shakeObj:Container = (StateSymbolWin.instance.getItem(reel,row,"normal")).itemContainer;
                    this.pTimeline.add(AnimationEffects.Shake({
                        x: 0.1,
                        y: 0.8,
                        obj: shakeObj,
                        duration:shakeDurr,
                        Intensity:5,
                        hertz:135,
                        positionCb: () => { return reelC.getCurrentStatePositionMap(shakeObj)[row + reelC.overflowDirection] }
                    }),totalDurr + shakeDurr*0.5);

                    if(JumpingWildController.instance.itemExists(reel,row) >= 0){
                        this.pTimeline.add(AnimationEffects.Shake({
                            x:0.1,
                            y:2,
                            obj: JumpingWildController.instance.getExistingItem(JumpingWildController.instance.itemExists(reel,row))!.cont,
                            duration:shakeDurr,
                            Intensity:3,
                            hertz:150,
                            positionCb: () => { return reelC.getCurrentStatePositionMap(shakeObj)[row+ reelC.overflowDirection ] }
                        }),totalDurr + shakeDurr*0.5);
                    }
               }
            }
        }
        this._winState.set(WinState.DONE);
    }

    protected addWinCountUpToTimeline():void {
        EventHandler.dispatchEvent(new GameEvent(SpinEvent.WANT_SKIPPABLE));

        const totalWin:number = this._gameData!.totalWin;
        const isTotalWin:boolean = totalWin != this._gameData.singleWin;

        let countUpDuration:number = this.winConfig.duration;
        WinCounter.winWayCounter.updateWinWays(this.totalWinWays);
        WinCounter.normalCounter.getCountUpAnimation(0, this.winAmount, countUpDuration);

        this.clickAble = true;
        const coundEndDelay:number = 0.4;

        if(this._gameData.punkBetWins.length == 1)
            this.pTimeline.to(ReelGraphicBackground.instance, 0.2, {alpha:0.5},0);

        // Start Wins
        for(let reel = 0; reel < this._gameData.allWinData.reelWinPositions.length;reel++){
            for(let row = 0; row < this._gameData.allWinData.reelWinPositions[reel].length;row++){
                if(this._gameData.allWinData.reelWinPositions[reel][row]){
                    if(JumpingWildController.instance.itemExists(reel,row) >= 0){
                        JumpingWildController.instance.PlayState(
                            JumpingWildController.instance.itemExists(reel,row),
                            JumpWildState.WIN
                        );
                    }else{
                        StateSymbolWin.instance.playSymbolStartWinAnimation({
                            ReelID:reel,
                            SymID:row,
                            duration: 1,
                            State:ReelSymbolStates.WIN,
                        });
                        StateSymbolWin.instance.playSpineAnimation({
                            ReelID:reel,
                            SymID:row,
                            State:ReelSymbolStates.WIN,
                        });
                    }
                }
            }
        }
        // Step Counter
        if (!PunkGameConfig.instance.WIN_BELOW_STAKE) { // #423
            SoundManager.playSoundEffect(this._soundWinTotal);
            SoundManager.playSoundEffect(SoundConfig.instance.NORMAL_COUNTUP, 10000000000);
        }
        this.pTimeline.add([
            () => this.clickAble = false,
            () => SoundManager.stopSoundEffect(SoundConfig.instance.NORMAL_COUNTUP),
            () => !PunkGameConfig.instance.WIN_BELOW_STAKE && SoundManager.playSoundEffect(SoundConfig.instance.NORMAL_COUNTUP_END), // 423
            () => WinCounter.normalCounter.playSizing(coundEndDelay + this.winIndx*0.1,(1.15)),
        ],countUpDuration, "-="+0.1)

        this.pTimeline.add(this._shatter.playAnimation({onStart:() => {this._shatter.alpha = 1}, onCompleteCallback:() => {this._shatter.alpha = 0}}),countUpDuration, "-="+0.1)
        this.pTimeline.add(() => WinCounter.winWayCounter.showWaysWon(1),"=-1.1");

        countUpDuration +=  1;
        // Stop Wins
        for(let reel = 0; reel < this._gameData.allWinData.reelWinPositions.length;reel++){
            for(let row = 0; row < this._gameData.allWinData.reelWinPositions[reel].length;row++){
                if(this._gameData.allWinData.reelWinPositions[reel][row]){
                    if(JumpingWildController.instance.itemExists(reel,row) == -1){
                        this.pTimeline.add(() => StateSymbolWin.instance.playSpineEndAnimation({
                            ReelID:reel,
                            SymID: row,
                            State:ReelSymbolStates.WIN,
                            duration:0.1,
                        }),countUpDuration)
                        this.pTimeline.add(() => StateSymbolWin.instance.playSymbolStopWinAnimation({
                            ReelID:reel,
                            SymID:row,
                            State:ReelSymbolStates.NORMAL,
                            duration:0.2,
                            }),countUpDuration)
                    }
                }
            }
        }

        // Reset and remove blackness.
        this.pTimeline.add([
            TweenLite.to(ReelGraphicBackground.instance, countUpDuration*0.4,{alpha:0}),
            () => PunkEngineManager.RSAll((reel:number,symid:number) => { if(!PunkEngineManager.getReel(reel).getSymbol(symid)!.isWild) PunkEngineManager.getReel(reel).getSymbol(symid)!.setActive(true)}
        )],countUpDuration);

        this.pTimeline.add(() => SlotGame.keypad.setWin(totalWin,isTotalWin, PunkGameModuleConfig.featurePrice.isWinBelowStake()));

        if(this._gameData.nextMode == GameMode.NORMAL) this.pTimeline.add(PunkBackground.instance.changeGraphicAlpha(0.2,0),"-="+0.2)
        this._winState.set(WinState.DONE);
    }

    public skipPresentation():void{
        if(this._winState.equal(WinState.DONE) && this.clickAble){
            SoundManager.stopSoundEffect(SoundConfig.instance.NORMAL_COUNTUP);
            // #423
            !PunkGameConfig.instance.WIN_BELOW_STAKE && SoundManager.playSoundEffect(SoundConfig.instance.NORMAL_COUNTUP_END);
            WinCounter.normalCounter.abort(this.winAmount,this._winState.equal(WinState.BIGWIN));
            WinCounter.normalCounter.playSizing(0.6,(1 + this.winIndx*0.1));
            this._shatter.playAnimation();
            this.clickAble = false;
            this.pTimeline.totalProgress(1);
        }
    }
}